import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import "@google/model-viewer";
import { environment } from '../../../../../../environments/environment';

@Component({
  selector: 'app-home-ar',
  templateUrl: './home-ar.component.html',
  styleUrls: ['./home-ar.component.scss']
})
export class HomeArComponent implements OnInit {
  floorPlan: any;
  project: any;
  canPreview;
  showAr: boolean = true;

  constructor(
    // private dialogRef: MatDialogRef<any>,
    // @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
    // this.floorPlan = this.data.floorPlan;
    // this.project = this.data.project;
    // this.canPreview = this.data.canPreview;
  }
  getHomeAr() {
    this.showAr = true
    const src = './assets/images/black/checked.png'
    return src
  }

  getFileUrl(fileName?: string) {
    if (!fileName) {
      return null;
    }
    return environment.VERIFICATION_CODE_URL + 'files/' + this.project.projectCode + '/floor_plans/' + fileName
  }

  // cancel() {
  //   this.dialogRef.close();
  // }
}
